const useUsers = () => {
  const drawerMenu = [];

  return {
    drawerMenu,
  };
};

export default useUsers;
